import React from 'react';
import { injectIntl } from 'react-intl';
import { Grid, Typography } from '@mui/material';
import './PolicyPickerInfo.scss';
import FigureUnitTypo from '../../../../components/FigureUnitTypo/FigureUnitTypo';
// import { useTheme } from "@mui/material/styles";
// import { formatNumber } from "../../../../utils/formatNumber";

const Style = {
  padding: 0
};

const ContainerStyle = {
  padding: '12px 16px',
  border: '1px solid var(--primary-main)',
  borderRadius: 8,
  backgroundColor: '#3966f808'
};

const FullWidthStyle = {
  width: '100%'
};

const BottomGridContainerStyle = {};

const LabelValueGridStyle = {
  flexGrow: 1,
  minWidth: 0
};

const PolicyPickerInfo = props => {
  const { intl, figures, button } = props;
  // const theme = useTheme();

  return (
    <div className="policy-picker-info" style={Style}>
      <Grid
        container
        style={ContainerStyle}
        sx={{
          flexDirection: 'column',
          rowGap: 1.5
        }}
      >
        <Grid style={FullWidthStyle}>
          <Grid
            container
            sx={{
              justifyContent: 'space-between',
              alignItems: 'flex-start'
            }}
          >
            <Grid>
              <Typography>{intl.formatMessage({ id: 'analy-picker-title' })}</Typography>
            </Grid>
            <Grid>{button}</Grid>
          </Grid>
        </Grid>
        <Grid style={FullWidthStyle}>
          <Grid
            container
            style={BottomGridContainerStyle}
            sx={{
              alignItems: 'flex-end',
              columnGap: 2,
              flexWrap: 'nowrap'
            }}
          >
            {(figures || []).map((figure, index) => {
              return (
                <Grid style={LabelValueGridStyle} key={index}>
                  {figure ? (
                    <Grid container sx={{ flexDirection: 'column', alignItems: 'flex-start' }}>
                      <Grid>
                        <Typography color="textSecondary">{figure.label}</Typography>
                      </Grid>
                      <Grid>
                        <FigureUnitTypo value={figure.value.value} unit={figure.value.unit} fontSizeRem={2} />
                      </Grid>
                    </Grid>
                  ) : null}
                </Grid>
              );
            })}
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default injectIntl(PolicyPickerInfo);
